export enum INTERNSHIP_LOCATIONS_ORDER_COLUMNS {
  CNPJ_OR_CPF = 'CNPJ_OR_CPF',
  NAME = 'NAME',
  ADDRESS = 'ADDRESS',
}
